import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userFeeSelector = ({ userFee }: ReducerState) => userFee;
export const userFeeLoadingSelector = createSelector(
  userFeeSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
